import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function ContactCTA() {
  const { t } = useTranslation();

  return (
    <section className="bg-slate-950 py-24 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{backgroundImage: 'radial-gradient(circle at 30% 50%, #00C9A7 0%, transparent 60%), radial-gradient(circle at 70% 50%, #1A56DB 0%, transparent 60%)'}}></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <AnimatedSection animation="fade-in">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-8">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line text-cyan-400 text-sm"></i>
            </div>
            <span className="text-cyan-400 text-sm font-medium">{t('cta_badge')}</span>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            {t('cta_title1')}<br />
            <span className="text-cyan-400">{t('cta_title2')}</span>
          </h2>
          <p className="text-slate-400 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
            {t('cta_desc')}
          </p>

          {/* Only one CTA button — WhatsApp 即時咨詢 removed */}
          <div className="flex justify-center mb-12">
            <Link
              to="/contact"
              className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-bold px-10 py-4 rounded-lg text-base transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              {t('cta_btn')}
            </Link>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-slate-400 text-sm">
            {(['cta_note1', 'cta_note2', 'cta_note3'] as const).map(key => (
              <div key={key} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-cyan-500"></i>
                </div>
                {t(key)}
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
